import { apiPost } from "../shared/apiClient";

// Pre-querysetV2 legacy `queryset` table history for a customer — read-only,
// display-only fields. See docs/superpowers/specs/2026-07-27-bring-query-to-today-design.md
// for why this is a separate endpoint from routes/whatsapp.js's existing
// /get_querysets (that one scopes results to the calling user unless
// they're admin, which isn't what a "show this customer's full old
// history" view wants).
export function fetchLegacyQueriesByCustomer(customerId) {
  return apiPost("/whatsapp/get_legacy_queries_by_customer", { customer_id: customerId })
    .then(res => (res.data?.success ? (res.data.data || []) : []))
    .catch(() => []);
}
